import { type ReactNode } from 'react'

import { type PODisclaimerLabel } from '@webapp/modules/purchasing/entities/PODisclaimerLabel'
import { PODisclaimerLabelTable } from '@webapp/modules/purchasing/features/list-po-disclaimer-labels/views/PODisclaimerLabelTable'
import { usePODisclaimerLabelListPresenter } from './usePODisclaimerLabelListPresenter'

export interface IPODisclaimerLabelListPresenterProps {
  defaultId: number | null
  onToggleDefault?: (label: PODisclaimerLabel) => void
  onDeleteLabel?: (label: PODisclaimerLabel) => void
  renderEditableCells?: (label: PODisclaimerLabel) => {
    description: ReactNode
    text: ReactNode
  }
}

export const PODisclaimerLabelListPresenter = ({
  defaultId,
  onToggleDefault,
  onDeleteLabel,
  renderEditableCells,
}: IPODisclaimerLabelListPresenterProps) => {
  const {
    data: { labels, numPages },
    states: { page, isLoading },
    methods: { onPrevPage, onNextPage },
  } = usePODisclaimerLabelListPresenter()

  return (
    <PODisclaimerLabelTable
      labels={labels}
      defaultId={defaultId}
      isLoading={isLoading}
      page={page}
      numPages={numPages}
      onPrevPage={onPrevPage}
      onNextPage={onNextPage}
      onToggleDefault={onToggleDefault}
      onDeleteLabel={onDeleteLabel}
      renderEditableCells={renderEditableCells}
    />
  )
}

PODisclaimerLabelListPresenter.displayName = 'PODisclaimerLabelListPresenter'
